module.exports = __webpack_public_path__ + "static/2016-community-9e87bb53578aed66a941acd8a48619f6.jpg";